angular.module('speedTestPageMod', [])

/* ===================================================================================== */
/* ============================== APPLICATIONS MANAGER CONTROLLER ====================== */
/* ===================================================================================== */

.controller('SpeedTestPageCtrl', ['$location', '$scope', 'cnfg', '$templateCache',
  function ($location, $scope, cnfg, $templateCache) {
    $scope.app_id = '13991';

    $scope.changePath = function (path) {
      $location.path(path);
    };

    $scope.fieldModel = {
      value: `
        // Returns information about the app
        import { GudHub } from '@gudhub/core';
        const gudhub = new GudHub(auth_key);
        gudhub.getAppInfo(appId);
      `
    };

    gudhub.getAppsList();

    const DBOpenRequest = window.indexedDB.open("gudhub", 4);

    DBOpenRequest.onsuccess = (event) => {
      console.log("Database initialized");
    };

    $scope.getAppLib = async () => {
      console.time('getAppLib');
      await gudhub.getApp($scope.app_id);
      console.timeEnd('getAppLib');
    }

    $scope.getAppManually = async () => {
      let app = null;
      let chunks = null;

      console.time('TOTAL TIME');
      console.time('Get app');

      const accessToken = gudhub.storage.user.accesstoken;
      const apiUrl = `https://gudhub.com/GudHub_Test/api/app/get?token=${accessToken}&app_id=${$scope.app_id}`;
      
      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          app = data;
          console.timeEnd('Get app');

          const db = DBOpenRequest.result;
          const transaction = db.transaction(["chunksMergeCache"], "readwrite");

          const objectStore = transaction.objectStore("chunksMergeCache");

          console.time("Get from DB");
          const objectStoreRequest = objectStore.get($scope.app_id);

          objectStoreRequest.onsuccess = () => {
            chunks = objectStoreRequest.result;
            console.timeEnd("Get from DB");

            const sourceItems = chunks.mergedData.items_list;
            const destinationItems = app.items_list;

            console.time('Merge items');
            gudhub.mergeItems(sourceItems, destinationItems);
            console.timeEnd('Merge items');

            console.timeEnd('TOTAL TIME');
          };
        });
    };
  }
]);